import {Col, Divider, Row, Space} from 'antd';
import {getListAPI} from 'api/common';
import {IconDownloadExcel} from 'components/assets/icons';
import {AlertModal, BaseContainer, SearchDesc} from 'components/containers';
import {AreaSearch, BranchSearch, DataGrid, DownloadButton, FillButton, ExcelButton} from 'components/elements';
import {BaseSection} from 'components/layouts';
import {areaTypeOptions} from 'data/options';
import {getLocalStorage} from 'hooks/useLocalStorage';
import {GridSetting} from 'pages/common';
import {UploadExcel, UploadExcelBranchRegion} from 'pages/common/UploadExcel';
import {useEffect, useState} from 'react';
import {exportStyleExcelDownload} from 'utils/file';
import {fnSetColumn, getAmountWithComma, utilSearchData} from 'utils/utils';

const BranchRegion = () => {
  const menu = getLocalStorage('openMenuInfo');
  const [colList, setColList] = useState({
    gridSettingList: [],
    gridList: []
  });
  const [data, setData] = useState();
  const [columns, setColumns] = useState([]);
  const [isUpload, setIsUpload] = useState(false);
  const [option, setOption] = useState({
    branch_idx: null,
    sigungu_cd: ''
  });
  const [gridSetting, setGridSetting] = useState([]);
  const [alertModal, setAlertModal] = useState({
    open: false,
    message: ''
  });
  const fnCloseAlertModal = () => {
    setAlertModal({...alertModal, open: false, message: ''});
  };

  const fnExcelDownload = () => {
    const processData = data?.map((item) => {
      let areaType = '';
      const area = areaTypeOptions.find((it) => it.value === item?.AREA_TYPE);
      areaType = area?.label;
      const obj = {}
      colList?.gridList.forEach(it => {
        if ('AREA_TYPE' === it.dataIndex) {
          obj['AREA_TYPE'] = areaType
        } else {
          obj[it.dataIndex] = item[it.dataIndex]
        }
      });
      return obj
    });

    const headerList = colList?.gridList.map(it => it.title)
    exportStyleExcelDownload(headerList, processData, menu?.depth?.[1]);
  };

  const fnExcelFormDown = () => {
    const processData = data?.map((item) => {
      let areaType = '';
      const area = areaTypeOptions.find((it) => it.value === item?.AREA_TYPE);
      areaType = area?.label;
      return {
        IDX: item?.IDX,
        BRANCH_ID: item?.BRANCH_ID,
        BRANCH_NAME: item?.BRANCH_NAME,
        SIDO: item?.SIDO,
        GUGUN: item?.GUGUN,
        AREA_TYPE: areaType,
        TOTAL_POPULATION_CNT: item?.TOTAL_POPULATION_CNT,
        POPULATION_5_9: item?.POPULATION_5_9,
        POPULATION_30_49: item?.POPULATION_30_49,
      };
    });

    const headerList = ['IDX', 'BRANCH_ID', 'BRANCH_NAME', 'SIDO', 'GUGUN', 'AREA_TYPE', 'TOTAL_POPULATION_CNT', 'POPULATION_5_9', 'POPULATION_30_49'];
    exportStyleExcelDownload(headerList, processData, `${menu?.depth?.[1]} 엑셀 양식`);
  };

  const fnGetList = async () => {
    try {
      // 공통 서치바 데이터 체크 및 데이터 리턴
      const result = utilSearchData(option);
      if (typeof result === 'string') {
        setAlertModal({...alertModal, open: true, message: result});
      } else {
        const {data} = await getListAPI(result);
        setColList({
          ...colList,
          gridSettingList: data?.COLUMS_LIST,
          gridList: fnSetColumn(data?.COLUMS_LIST, column)
        });
        setData(data?.DATA_LIST);
        setGridSetting(data?.COLUMS_LIST);
        setColumns(fnSetColumn(data?.COLUMS_LIST, column));
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsUpload(false);
    }
  };


  useEffect(() => {
    fnGetList();
  }, []);

  useEffect(() => {
    if (isUpload) fnGetList();
  }, [isUpload])

  const column = [
    {
      title: '지사아이디',
      align: 'center',
      dataIndex: 'BRANCH_ID',
      defaultSortOrder: 'descend',
      sorter: (a, b) => {
        if (a?.BRANCH_ID > b?.BRANCH_ID) return -1;
        if (a?.BRANCH_ID < b?.BRANCH_ID) return 1;
        return 0;
      },
    },
    {
      title: '지사명',
      align: 'center',
      dataIndex: 'BRANCH_NAME',
      defaultSortOrder: 'descend',
      sorter: (a, b) => {
        if (a?.BRANCH_NAME > b?.BRANCH_NAME) return -1;
        if (a?.BRANCH_NAME < b?.BRANCH_NAME) return 1;
        return 0;
      },
    },
    {
      title: '지역',
      align: 'center',
      dataIndex: 'SIDO',
      defaultSortOrder: 'descend',
      sorter: (a, b) => {
        if (a?.SIDO > b?.SIDO) return -1;
        if (a?.SIDO < b?.SIDO) return 1;
        return 0;
      },
    },
    {
      title: '행정구역(소)',
      align: 'center',
      dataIndex: 'GUGUN',
      defaultSortOrder: 'descend',
      sorter: (a, b) => {
        if (a?.GUGUN > b?.GUGUN) return -1;
        if (a?.GUGUN < b?.GUGUN) return 1;
        return 0;
      },
    },
    {
      title: '지역구분',
      align: 'center',
      dataIndex: 'AREA_TYPE',
      defaultSortOrder: 'descend',
      sorter: (a, b) => {
        if (a?.AREA_TYPE > b?.AREA_TYPE) return -1;
        if (a?.AREA_TYPE < b?.AREA_TYPE) return 1;
        return 0;
      },
      render: (text) => {
        const area = areaTypeOptions?.find((it) => it.value === text);
        return area?.label;
      }
    },
    {
      title: '총인구수',
      align: 'center',
      dataIndex: 'TOTAL_POPULATION_CNT',
      sorter: (a, b) => {
        return a.TOTAL_POPULATION_CNT - b.TOTAL_POPULATION_CNT
      },
      render: (text) => getAmountWithComma(text),
    },
    {
      title: '인구(5-9세)',
      align: 'center',
      dataIndex: 'POPULATION_5_9',
      sorter: (a, b) => a.POPULATION_5_9 - b.POPULATION_5_9,
      render: (text) => getAmountWithComma(text),
    },
    {
      title: '인구(30-49세)',
      align: 'center',
      dataIndex: 'POPULATION_30_49',
      sorter: (a, b) => a.POPULATION_30_49 - b.POPULATION_30_49,
      render: (text) => getAmountWithComma(text),
    }
  ];

  const fnChangeArea = (e, item) => {
    let obj = {};
    if (item === 'sido') {
      obj = {
        [item]: e
      };
    }
    if (item === 'sigungu_cd') {
      obj = {
        [item]: e
      };
    }
    setOption({...option, ...obj});
  };

  const items = [
    {
      key: 1,
      label: '지사',
      children: <BranchSearch branchIdx={option?.branch_idx} onSelect={v => setOption({...option, branch_idx: v?.value})} />
    },
    {
      key: 2,
      label: '지역',
      children: <AreaSearch onSelect={fnChangeArea}/>,
    },
    {
      key: 3,
      label: <FillButton label="검색하기" width="100px" backgroundColor="var(--color-gray03)" onClick={fnGetList}/>,
    }
  ];

  //표설정 변경시 테이블 항목 업데이트
  const fnUpdateGridSetting = (v) => {
    setColList({
      ...colList,
      gridList: fnSetColumn(v, column)
    });
    setColumns(fnSetColumn(v, column));
    setGridSetting(v);
  };

  return (
    <BaseSection>
      <SearchDesc inline items={items} column={items?.length} labelStyle={{width: '50px'}}/>
      <BaseContainer>
        <Row>
          <Col span={24}>
            <Space>
              <GridSetting colList={gridSetting} fnUpdateCol={fnUpdateGridSetting}/>
              <ExcelButton
                // label={'엑셀 다운로드(검색)'} //뷰네임 미입력시 기본값
                // isCheckComp={true} //체크박스 컴포넌트 여부 미입력시 X
                headerList={columns} //필수 헤더리스트 표 설정과 동일한 변수여야함
                gridList={data} //필수 실시간 그리드 데이터
                // filterList={[]} //뺄 칼럼 목록 dataIndex 미입력시 dataIndex 키 없는것만 뺌
                // renderList={[]} //코드 or 다른이름으로 바꿔서 다운할 목록
                // checkRows={} //isCheckComp true 일시 checkRows 데이터 미입력시 체크작동안함
                // checkKey={} //isCheckComp true 일시 check 한 데이터 dataIndex 키 네임 미입력시 체크작동안함
                // fileName={} //파일네임 미입력시 해당 메뉴이름
              />
              <DownloadButton text="지역변경 엑셀 양식 다운로드" color={'var(--color-green01)'} onClick={fnExcelFormDown}/>
              <UploadExcelBranchRegion text="지역변경 엑셀 업로드" onOk={setIsUpload}/>
            </Space>
            <Divider className="divider-small"/>
            <DataGrid rowKey={(record) => `${record.IDX}`} columns={columns} data={data} pagination/>
          </Col>
        </Row>
      </BaseContainer>
      <AlertModal open={alertModal?.open} onCancel={fnCloseAlertModal}>
        {alertModal?.message}
      </AlertModal>
    </BaseSection>
  );
};

export default BranchRegion;
